import { BaseModel } from '../base-model';
import { ItemStateModel } from '../base-itemstate';

export interface IPropertyDescriptionModel extends ItemStateModel {
  PropertyId?: number;
  LanguageId?: number;
  PubTextA?: string;
  PubTextB?: string;
  PubTextC?: string;
  PubTextD?: string;
  DescriptionA?: string;
  DescriptionHTMLA?: string;
  DescriptionB?: string;
  DescriptionHTMLB?: string;

}
export class PropertyDescriptionModel extends BaseModel<IPropertyDescriptionModel> implements IPropertyDescriptionModel {
  PropertyId?: number;
  LanguageId?: number;
  PubTextA?: string;
  PubTextB?: string;
  PubTextC?: string;
  PubTextD?: string;
  DescriptionA?: string;
  DescriptionHTMLA?: string;
  DescriptionB?: string;
  DescriptionHTMLB?: string;
  /**
   *
   */
  constructor(option?: IPropertyDescriptionModel) {
    super(option);
    this.DescriptionHTMLA = this.DescriptionA || "";
    this.DescriptionHTMLB = this.DescriptionHTMLB || "";
  }
}


export class PropertyDescriptionUpdateModel  {
  Id: number;
  LanguageId: number;
  Field: string;
  Value: object
}